import { render, staticRenderFns } from "./SocietyMatchesAddContactContainer.vue?vue&type=template&id=0648a5ae&scoped=true"
import script from "./SocietyMatchesAddContactContainer.vue?vue&type=script&lang=js"
export * from "./SocietyMatchesAddContactContainer.vue?vue&type=script&lang=js"
import style0 from "./SocietyMatchesAddContactContainer.vue?vue&type=style&index=0&id=0648a5ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648a5ae",
  null
  
)

export default component.exports